<template>
  <div class="cashcreation">
    <div class="header-text"
         :style="{ width: ElementHeight }">
      <h1 class="header-title">异业劵库管理-查看</h1>
      <div class="buttom-div">
        <el-button class="push-button"
                   icon="iconfont icon-fanhui"
                   @click="backHistory">返回</el-button>
      </div>
    </div>
    <div class="header-text1"></div>
    <div class="biaoti">
      <span>基本信息</span>
    </div>
    <div>
      <el-card>
        <!-- 表单 -->
        <div>
          <el-form disabled
                   :label-position="labelPosition"
                   label-width="150px"
                   size="small"
                   class="form-div"
                   ref="BasicInformation"
                   :model="BasicData">
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券库编号">
                  <el-input readonly v-model="BasicData.coupGrpNo"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="状态">
                  <el-input readonly v-model="BasicData.state"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="劵号生成方式">
                  <el-select style="width: 100%"
                             v-model="BasicData.SecuritygenerationMethod">
                    <el-option v-for="(item, index) in Securitygeneration"
                               :key="index"
                               :label="item.lable"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="券库名称"
                              prop="couponsName">
                  <el-input readonly
                            v-model="BasicData.couponsName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item label="券库后台名称"
                              prop="innerCoupName">
                  <el-input readonly
                            v-model="BasicData.innerCoupName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">

              <el-col :span="9">
                <el-form-item label="使用需知"
                              prop="usageNotice">
                  <el-input type="textarea"
                            readonly
                            class="textareaClass"
                            :autosize="{ minRows: 4, maxRows: 8 }"
                            v-model="BasicData.usageNotice">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="9">
                <el-form-item label="礼品不可转赠">
                  <el-checkbox-group v-model="BasicData.ifGiving">
                    <el-checkbox :checked="BasicData.ifGiving"
                                 v-model="BasicData.ifGiving"
                                 name="type"></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券有效期"
                              prop="SecuritiesExpirationTypeSelect">
                  <el-radio-group v-model="BasicData.SecuritiesExpirationTypeSelect"
                                  class="periodOfValidity">
                    <el-form-item prop="123">
                      <el-radio :label="SecuritiesExpirationType[0].id">永不过期</el-radio>
                    </el-form-item>
                    <el-form-item prop="validDaySdata">
                      <el-radio :label="SecuritiesExpirationType[1].id">
                        <span style="font-size: 14px">有效期天数，从领券日期起</span>
                        <el-input :disabled="
                            BasicData.SecuritiesExpirationTypeSelect != 2
                          "
                                  readonly
                                  style="width: 90px"
                                  type="Number"
                                  v-model="BasicData.validDaySdata"></el-input>
                        <span style="font-size: 14px">天内有效</span>
                      </el-radio>
                    </el-form-item>
                    <el-form-item prop="datePicker">
                      <el-radio :label="SecuritiesExpirationType[2].id">
                        <span style="font-size: 14px">有效期范围从</span>
                        <el-date-picker :disabled="
                            BasicData.SecuritiesExpirationTypeSelect != 3
                          "
                                        readonly
                                        v-model="BasicData.datePicker"
                                        type="daterange"
                                        start-placeholder="开始日期"
                                        end-placeholder="结束日期">
                        </el-date-picker>
                      </el-radio>
                    </el-form-item>
                    <el-form-item prop="123">
                      <el-radio :label="SecuritiesExpirationType[3].id">导入时填写</el-radio>
                    </el-form-item>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券发送提醒">
                  <el-radio-group v-model="BasicData.pubCoupProvideMode">
                    <el-radio v-for="(item, index) in CouponreminderMethod"
                              :key="index"
                              :label="item.id">{{ item.detailText }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24">
                <el-form-item label="券核销提醒">
                  <el-radio-group v-model="BasicData.pubVeriCoupMode">
                    <el-radio v-for="(item, index) in CouponreminderMethod"
                              :key="index"
                              :label="item.id">{{ item.detailText }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="100">
              <el-col :span="24"
                      class="MaturityOfSecurities">
                <el-form-item label="券到期提醒">
                  <el-radio-group v-model="BasicData.expirationMode">
                    <el-radio v-for="(item, index) in CouponreminderMethod"
                              :key="index"
                              :label="item.id">{{ item.detailText }}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item prop="expirationTime"
                              style="margin-left: -50px">
                  <span style="font-size: 14px">券到期前</span>
                  <el-input style="width: 90px"
                            type="Number"
                            readonly
                            v-model="BasicData.expirationTime"></el-input>
                  <span style="font-size: 14px">天提醒</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { couponsGroupDetail } from "@/api/couponsDepot.js";
import { mapState } from "vuex";
export default {
  data () {
    return {
      screenWidth: "",
      ElementHeight: "0px",
      Securitygeneration: [
        {
          id: "0",
          lable: "卷库自动生成",
        },
        {
          id: "1",
          lable: "导入劵号",
        }
      ],
      SecuritiesExpirationType: [
        {
          id: 1,
          detailText: "永不过期",
        },
        {
          id: 2,
          detailText: "从发卷开始固定日期",
        },
        {
          id: 3,
          detailText: "固定过期时间",
        },
        {
          id: 4,
          detailText: "导入时填写",
        },
      ],
      CouponreminderMethod: [
        {
          id: 0,
          detailText: "不提醒",
        },
        {
          id: 1,
          detailText: "公众号模板消息",
        },
        {
          id: 2,
          detailText: "短信消息",
        },
        {
          id: 3,
          detailText: "公众号模板消息和短信消息",
        },
      ],
      BasicData: {
        //基本信息
        SecuritygenerationMethod: '0',
        couponsName: "", //券库名称
        innerCoupName: "", //券库后台名称
        usageNotice: "", //使用需知
        ifGiving: false, //礼品是否可以转送
        SecuritiesExpirationTypeSelect: 1, //选择的劵有效期方式
        validDaySdata: "  ",
        datePicker: "  ", //有效期
        pubCoupProvideMode: 0, //券发放提醒方式
        expirationMode: 0, //到期提醒方式
        pubVeriCoupMode: 0, //券核销提醒方式
        expirationTime: 0, //到期提醒时间
      },
      labelPosition: "right"
    };
  },
  computed: {
    ...mapState({
      CouponsSelectChang: (state) => state.user.CouponsSelectChang,
    }),
  },
  watch: {
    //窗口宽度变化
    screenWidth (val) {
      this.ElementHeight =
        document.querySelector(".cashcreation").offsetWidth + "px";
    },
  },
  mounted () {
    this.getELmentHeight(); //获取页面高度
  },
  created () {
    this.RcouponsGroupDetail(); //卷库详情
  },
  methods: {
    getELmentHeight () {
      this.screenWidth = document.body.clientWidth;
      window.onresize = () => {
        return (() => {
          this.screenWidth = document.body.clientWidth;
        })();
      };
    },
    RcouponsGroupDetail () {
      let arr = ''
      if (this.$route.query.cur === undefined) {
        arr = this.CouponsSelectChang.couponsGrpID
      } else {
        arr = this.$route.query.cur
      }
      let data = require("qs").stringify({
        couponsGrpID: arr,
      });
      couponsGroupDetail(data).then((res) => {
        if (res.success) {
          this.BasicData.SecuritygenerationMethod = res.data.buildCoupMode.toString();
          this.BasicData.coupGrpNo = res.data.coupGrpNo; //礼券编号
          this.BasicData.state =
            res.data.state == 0
              ? "启用"
              : res.data.state == 1
              ? "未启用"
              : res.data.state == 2
              ? "已禁用"
              : ""; //礼券状态
          this.BasicData.couponsName = res.data.couponsName; //礼券名称
          this.BasicData.innerCoupName = res.data.innerCoupName; //礼券后台名称
          this.BasicData.usageNotice = res.data.usageNotice; //使用需知
          this.BasicData.ifGiving = res.data.ifGiving; //礼品是否可以转送
          this.BasicData.validDaySdata = res.data.validDay; //券有效日期
          let datePicker = [];
          datePicker[0] = this.renderTime(res.data.startDate); //开始日期
          datePicker[1] = this.renderTime(res.data.endDate); //结束日期
          this.BasicData.datePicker = datePicker;
          this.BasicData.expirationTime = res.data.expirationTime; //到期提醒时间
          this.BasicData.SecuritiesExpirationTypeSelect =
            res.data.timeLimitKind; //选择的劵有效期方式
          this.BasicData.pubCoupProvideMode = res.data.pubCoupProvideMode; //券发放提醒方式
          this.BasicData.expirationMode = res.data.expirationMode; //到期提醒方式
          this.BasicData.pubVeriCoupMode = res.data.pubVeriCoupMode; //券核销提醒方式
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    renderTime (date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName ({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    backHistory () {
      this.$router.go(-1); //返回上一层
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-magin {
  margin-top: -30px;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.search-div {
  display: flex;
  justify-content: flex-end;
}
.elUpload {
  box-sizing: border-box;
  border: none;
  display: flex;
  justify-content: center;
  width: 98px;
  height: 34px;
}
.buttom-flex {
  display: flex;
  flex-direction: row;
}
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.margig-left80 {
  margin-left: 80px !important;
}
.formClass {
  margin-top: 10px;
}
.SelectArea {
  display: flex;
  margin-top: 8px;
  width: 140px;
}
.CategoryFiltering-div-top {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.CategoryFiltering-div {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 100%;
}
.CategoryFiltering-conter {
  // border: 1px solid #a8a8a8;
  display: flex;
  width: 1120px;
  height: 100%;
  margin-top: -15px;
}
.CategoryFiltering {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 700px;
  margin-top: 20px;
}
.right-top {
  display: flex;
  flex-direction: column;
  height: 430px;
}
.right-buttom {
  display: flex;
  flex-direction: column;
  height: 430px;
  margin-top: 20px;
}
.part-class-right {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.part-class-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  height: 470px;
}
.Coupons-part {
  display: flex;
  flex-direction: row;
  height: 100%;
  margin-left: 50px;
}
.Conpone-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 50px;
}
.MaturityOfSecurities {
  display: flex;
}
.periodOfValidity {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-div {
  padding: 20px 0px;
  padding-left: 100px;
}
.textareaClass {
  resize: none;
  width: 100%;
}
.textareaClass-store {
  padding: 2px 10px;
}
.cashcreation {
  margin-bottom: 100px;
}
.push-button {
  width: 100px;
  background-color: #e9e7d3;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  height: 50px;
}
.header-title {
  min-width: 250px;
  line-height: 50px;
  height: 50px;
}
.header-text1 {
  height: 3.5rem;
}
.header-text {
  position: fixed;
  z-index: 88;
  margin-top: -1.25rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  background-color: #f3f5f7;
  height: 4.5rem;
  color: #76734f;
  padding-bottom: 5px;
}
.biaoti {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  padding-left: 50px;
  background-color: #e3e3e3;
}
::v-deep {
  .el-card__body {
    padding: 20px 0 20px 0;
  }
  // 选择门店弹框样式
  .outlet {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 10px 20px 10px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
}
</style>
